import { axiosFactory } from './axiosFactory'

export const axiosUUID = axiosFactory.getAxios('uuid')
